<template>
  <div class="modal-content min-w-xs">
    <svg-icon
      name="callout-check"
      class="w-12 h-12 mx-auto text-green-400"
    />
    <h2 class="modal-title text-center ml-8">
      {{ pack?.title || 'Bundle' }} Added!
    </h2>
    <p class="text-center">
      We've added the following
      <br>
      flavors to your box.
    </p>
    <div>
      <p>
        <b>Flavors Added to Box:</b>
      </p>
      <ul>
        <li v-for="item in store.selectedProducts" :key="item.product?.key">
          {{ item.quantity }} &times; {{ item.product?.title }}
        </li>
      </ul>
    </div>
    <!-- <button
      class="button +border basis-1/2"
      @click="closeModal"
    >
      Review Flavors
    </button> -->
    <div class="flex justify-center gap-4 whitespace-nowrap">
      <button
        class="hidden lg:flex button +border grow"
        @click="closeModal()"
      >
        Close
      </button>
      <button
        class="lg:hidden button +border basis-1/2"
        @click="closeModal()"
      >
        Edit Flavors
      </button>
      <button
        class="lg:hidden button +green basis-1/2"
        @click="closeModal(true)"
      >
        View Cart
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useBundleStore, useThemeStore } from '@/stores'
import { showBundleSummary } from '@/utils/bundle'
import type { GraphqlVarietyPack } from '@/types/shopify'

const { modal } = useThemeStore()
const store = useBundleStore()

defineProps<{
  pack: GraphqlVarietyPack
}>()

const closeModal = (showSummary?: boolean) => {
  modal.close()
  if (showSummary) {
    showBundleSummary()
  }
}
</script>

<style>
.variety-pack-confirmation-modal .modal {
  width: auto !important;
}
</style>
